declare namespace $ {

	type $mol_button_major__hint_bog_pazzle_menu_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_button_major__click_bog_pazzle_menu_2 = $mol_type_enforce<
		ReturnType< $bog_pazzle_menu['play'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_pazzle_menu_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__hint_bog_pazzle_menu_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_button_major__click_bog_pazzle_menu_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle_menu['home'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_pazzle_menu_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_minor__hint_bog_pazzle_menu_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_menu_8 = $mol_type_enforce<
		ReturnType< $bog_pazzle_menu['saves'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_pazzle_menu_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_pazzle_menu_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_menu_11 = $mol_type_enforce<
		ReturnType< $bog_pazzle_menu['help'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_pazzle_menu_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_pazzle_menu extends $mol_list {
		Resume_icon( ): $mol_icon_play
		Resume( ): $mol_button_major
		New_icon( ): $mol_icon_image_plus
		New( ): $mol_button_major
		Saves_icon( ): $mol_icon_content_save
		saves_label( ): string
		Saves( ): $mol_button_minor
		Help_icon( ): $mol_icon_help
		Help( ): $mol_button_minor
		menu_content( ): readonly(any)[]
		resumable( ): boolean
		saves_count( ): number
		home( next?: any ): any
		play( next?: any ): any
		saves( next?: any ): any
		help( next?: any ): any
		rows( ): ReturnType< $bog_pazzle_menu['menu_content'] >
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map